import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { LinearIssuesProps } from "./types";

export const details = {
  name: "LinearIssues",
  description: "List and search issues from a Linear team or project",
  tags: ["Business", "Productivity", "Organization"],
  category: "Linear",
  grid: {
    Medium: [3, 3],
    Large: [4, 4],
  },
  integrationsUsed: ["linear"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  defaultProps: {},
} as ElementDetails<LinearIssuesProps>;
